/* eslint-disable */
/* TODO: enable @Shajansheriff */
import { Space, Tooltip } from 'antd';
import { SorterResult, SortOrder } from 'antd/es/table/interface';
import { ColumnsType } from 'antd/lib/table';
import { User } from 'api/models';
import { Project } from 'api/project';
import { CsatRating, Template } from 'api/reports/csat';
import { Avatar } from 'components/atoms/avatar';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { IconShell } from 'components/atoms/icon-shell';
import { MilestoneCompleted } from 'components/atoms/icons';
import { Rate } from 'components/atoms/rate';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { fullName } from 'utils/full-name';
import { GroupBy } from '../group-by';

const stringBasedSorting = (
  nameA: string | undefined,
  nameB: string | undefined,
) => {
  if (!nameA) {
    return -1;
  }
  if (!nameB) {
    return -1;
  }
  const A = nameA.toLowerCase();
  const B = nameB.toLowerCase();

  if (A < B) {
    return -1;
  }

  if (A > B) {
    return 1;
  }

  return 0;
};

export const getColumns = (
  groupByKey: GroupBy,
  sortInfo: SorterResult<CsatRating>,
): ColumnsType<CsatRating> =>
  [
    {
      dataIndex: 'project',
      title: <FormattedMessage id={GroupBy.Project} />,
      key: GroupBy.Project,
      width: '400px',
      render: (value: Project) => (
        <Space size="small">
          <Avatar
            src={value.customer.companyLogoUrl}
            name={value.customer.companyName}
          />
          <div>{value.projectName}</div>
        </Space>
      ),
      sortOrder:
        (sortInfo.columnKey === GroupBy.Project && sortInfo.order) || null,
      sorter: (a: CsatRating, b: CsatRating) =>
        stringBasedSorting(a.project.projectName, b.project.projectName),
    },
    {
      dataIndex: 'taskTemplate',
      key: GroupBy.Milestone,
      width: '400px',
      title: <FormattedMessage id={GroupBy.Milestone} />,
      sorter: (a: CsatRating, b: CsatRating) => {
        const nameA = a.taskTemplate ? a.taskTemplate.templateName : a.taskName;
        const nameB = b.taskTemplate ? b.taskTemplate.templateName : b.taskName;

        return stringBasedSorting(nameA, nameB);
      },
      sortOrder:
        (sortInfo.columnKey === GroupBy.Milestone && sortInfo.order) || null,
      render: (value: Template | undefined, record: CsatRating) => (
        <Space size={0} align="center">
          <IconShell icon={<MilestoneCompleted />} />
          {value ? value.templateName : record.taskName}
        </Space>
      ),
    },
    {
      dataIndex: 'actionBy',
      key: 'actionBy',
      width: '400px',
      title: <FormattedMessage id="rated_by" />,
      sorter: (a: CsatRating, b: CsatRating) =>
        stringBasedSorting(fullName(a.actionBy), fullName(b.actionBy)),
      sortOrder: (sortInfo.columnKey === 'actionBy' && sortInfo.order) || null,
      render: (value: User) => (
        <Space>
          <Avatar src={value?.photoUrl} name={fullName(value)} />
          <div>{fullName(value)}</div>
        </Space>
      ),
    },
    {
      dataIndex: 'rating',
      key: GroupBy.Rating,
      width: '400px',
      title: <FormattedMessage id={GroupBy.Rating} />,
      sorter: (a, b) => a.rating - b.rating,
      sortOrder:
        (sortInfo.columnKey === GroupBy.Rating && sortInfo.order) || null,
      render: (value: number) => <Rate disabled value={value} />,
    },
    {
      dataIndex: 'comment',
      key: 'comment',
      width: '400px',
      title: <FormattedMessage id="comment" />,
      render: (value: string) => (
        <Tooltip placement="topLeft" mouseEnterDelay={1} title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      dataIndex: 'actionAt',
      key: 'actionAt',
      width: '400px',
      defaultSortOrder: 'descend' as SortOrder,
      sorter: (a: CsatRating, b: CsatRating) => a.actionAt - b.actionAt,
      sortOrder: (sortInfo.columnKey === 'actionAt' && sortInfo.order) || null,
      title: <FormattedMessage id={GroupBy.ResponseDate} />,
      render: (value: number) => <HumanisedDate timestamp={moment(value)} />,
    },
  ].filter((c) => c.key === GroupBy.Milestone || c.key !== groupByKey);
